import {MegaScreen} from "./MegaScreen.js";
import {CLIENT_TYPE_SCREEN} from '@megaphonenpm/mrtsclient/src/constants.js';
import {notNil} from '@megaphonenpm/mputils/src/utils.js';
import {MRTSConnectionEvent} from '@megaphonenpm/mrtsclient/src/MRTSConnectionEvent.js';


/**
 * The OrphanSceneMediaLoader class is a special utility for loading media for "orphan scenes,"
 * which occur when the run's current scene is not present in the run's current active playlist.
 *
 * A scene becomes orphaned in two cases:
 *  1) When the run's current scene has been deleted from the Active Playlist and the run has not
 *     yet advanced out of the scene
 *  2) When the Active Playlist changes and the run has not yet advanced out of the current scene
 *
 * As an example, consider the following sequence involving two playlists, "A" and "B":
 *  1) A run starts, and advances to Scene 1 in "Playlist A"
 *  2) In Director or Editor, the Active Playlist is changed to "Playlist B"
 *  3) A new MegaScreen instance connects to MRTS. At this stage, the current scene sent to
 *      MegaScreen is Scene 1 from "Playlist A," but the playlist sent to MegaScreen is "Playlist B"
 *
 * In the above example, during the boot sequence, MegaScreen's LoadMediaTask loads all media from
 * "Playlist B," but "Playlist B" does not contain Scene 1, the "orphan scene," from "Playlist A,"
 * so LoadMediaTask does not load the orphan scene's media.
 *
 * To ensure media loads even for orphan scenes, the class OrphanSceneMediaLoader listens for all
 * scenes received by MRTSConnection from MRTS. If any scene received from MRTS is not found in the
 * current playlist, OrphanSceneMediaLoader loads its media.
 */
export class OrphanSceneMediaLoader {

  constructor (mrtsConnection, mediaCache) {
    this.mrtsConnection = mrtsConnection;
    this.mrtsConnection.on(MRTSConnectionEvent.SCENE_RECEIVED, this.sceneReceivedListener.bind(this));

    this.mediaCache = mediaCache;
  }

  sceneReceivedListener (e) {
    let currentMRTSScene = e.detail.scene;
    let currentPlaylistContainsCurrentMRTSScene = notNil(MegaScreen.globals.playlistService.getSceneByID(currentMRTSScene.id));

    if (!currentPlaylistContainsCurrentMRTSScene) {
      let currentSceneScreenMediaURIs = MegaScreen.globals.playlistService.getPlaylistMediaURIs(
        currentMRTSScene,
        CLIENT_TYPE_SCREEN);
      console.log('Current scene not found in active playlist. Queuing scene media to be loaded:', currentSceneScreenMediaURIs);
      this.mediaCache.load(currentSceneScreenMediaURIs);
    }
  }
}

